import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBIwLDI7Dn1xjDOJUc_CPaY8mUCLdhL09c",
  authDomain: "pomotask-d1a49.firebaseapp.com",
  projectId: "pomotask-d1a49",
  storageBucket: "pomotask-d1a49.appspot.com",
  messagingSenderId: "786217002849",
  appId: "1:786217002849:web:0295dc2731515cbbef8720",
  measurementId: "G-SLBNJ8VMX1"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
